import { jsx } from '@emotion/react';
import { InteractiveTagIcon } from './InteractiveTagIcon.es.js';
import { InteractiveTagWrapper } from './InteractiveTagWrapper.es.js';

const InteractiveTag = ({ children, color, href, iconAfter, iconAfterAriaHidden = true, iconAfterAriaLabel, iconBefore, iconBeforeAriaHidden = true, iconBeforeAriaLabel, onClick, maxWidth = "none" }) => {
  return jsx(
    InteractiveTagWrapper,
    { color, href, onClick, maxWidth },
    iconBefore && jsx(InteractiveTagIcon, { ariaHidden: iconBeforeAriaHidden, ariaLabel: iconBeforeAriaLabel, name: iconBefore, position: "before" }),
    children,
    iconAfter && jsx(InteractiveTagIcon, { ariaHidden: iconAfterAriaHidden, ariaLabel: iconAfterAriaLabel, name: iconAfter, position: "after" })
  );
};

export { InteractiveTag };
//# sourceMappingURL=InteractiveTag.es.js.map
